export const shouldShowDatePickers = (): boolean =>
  !!~window.location.href.indexOf('/training') || !!~window.location.href.indexOf('/ai-knowledge-replies')
